import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class DeluxePlayerPlaylistComponent extends Component {
  @tracked showSpoilers = false;
  get lastItem() {
    return _.sortBy(this.args.feed.items || [], ['playedAt']).pop();
  }
}
